import React, { useState } from 'react';

import { Divider } from '@material-ui/core';

import { Tile } from ".";
import { ColorPicker, ImageUpload, PackageImport, Select, TitleInput } from '../EditorFormElements';
import { FormFieldWrapper, SortableList } from '../Global';
import { EditorTabs } from '../Interface';
import { themeColors, tileLabelOptions, tileHeadingSizeOptions, tileHeadingStyleOptions, titleRTEOptions } from '../../config/slider';


export const SliderForm = ({given, ...props}) => {
  const [theme, setTheme] = useState('')
  const [tileType, setTileType] = useState('')
  const [tileHeadingStyle, setTileHeadingStyle] = useState('')

  const includePretitle = () => {
    if (tileHeadingStyle && tileHeadingStyle.indexOf('pretitle') >= 0) {
      return true;
    }
    return false;
  }

  const onColorPickerChange = (name,value) => setTheme(value);
  const onTileTypeChange = (name,value) => setTileType(value);
  const onTileHeadingChange = (name,value) => setTileHeadingStyle(value);

  const generalTab = (
    <>
      <PackageImport />
      
      <FormFieldWrapper>      

        <TitleInput 
          label="Item Title"
          wysiwyg={theme === 'orange'}
          help={theme === 'orange' ? 'If using the orange theme, part of the title needs to be emphasized. Select part of the title and apply the bold style.' : ''}
          controls={titleRTEOptions.controls}
          defaultText="Enter item <strong>title</strong>"
          // inlineToolbarControls={titleRTEOptions.controls}
          given={given.displayTitle}
        />

      </FormFieldWrapper>
    </>
  )

  const stylesTab = (
    <FormFieldWrapper>
      <ColorPicker 
        name="theme"
        label="Color Theme" 
        colors={themeColors} 
        callback={onColorPickerChange} 
        given={given.theme}
      />

      <Divider/>
                
      <ImageUpload 
        label="Background Image" 
        name="bg"
        given={given.bg}
        optional
        tooltip="Upload an image to display in the background of the slider. Image size must be 1920px by 1142px and must not exceed 950KB."
        help="This image is optional."
      />

      <Divider/>

      <Select 
        label="Tile Label Type"
        name='tileType' 
        options={tileLabelOptions}
        given={given.tileType}
        callback={onTileTypeChange} 
      /> 

      <Select 
        label="Tile Heading Style" 
        name='tileHeadingStyle' 
        options={tileHeadingStyleOptions}
        given={given.tileHeadingStyle}
        callback={onTileHeadingChange} 
      /> 

      <Select 
        label="Tile Heading Size" 
        name='tileHeadingSize' 
        options={tileHeadingSizeOptions}
        given={given.tileHeadingSize}
      /> 

    </FormFieldWrapper>
  )

  const contentTab = (
    <SortableList
      label="Tile"
      name="tiles"
      given={given.tiles}
      min={3}
      max={12}
    >
      <Tile
        pretitle={includePretitle()}
        type={tileType}
      />
    </SortableList>
  )

  return (
    <EditorTabs
      general={generalTab}
      styles={stylesTab}
      content={contentTab}
    />
  );

}